import { AppError } from "./AppError";

//

export class KaspiCabinetAuthDataError extends AppError {
  constructor(merchantId?: string | number) {
    super(
      `Неверные данные для входа в Kaspi магазин${merchantId ? ` (id: ${merchantId})` : ""}. Обновите логин/пароль магазина.`,
      {
        isOperational: true,
        statusCode: 400,
      },
    );

    this.name = "KaspiAuthDataError";
    Error.captureStackTrace(this, KaspiCabinetAuthDataError);
  }
}

export class KaspiCabinetInactiveError extends AppError {
  constructor(merchantId: string | number) {
    super(`Кабинет ${merchantId} заблокирован на стороне Kaspi.`, {
      isOperational: true,
      statusCode: 400,
    });
    this.name = "KaspiCabinetInactiveError";
    Error.captureStackTrace(this, KaspiCabinetInactiveError);
  }
}

export class KaspiProductNotAllowedError extends AppError {
  constructor(message?: string) {
    super(message ?? "Нет разрешения на подключение товара.", {
      isOperational: true,
      statusCode: 400,
    });
    this.name = "KaspiCabinetInactiveError";
    Error.captureStackTrace(this, KaspiProductNotAllowedError);
  }
}
